import * as requestFromServer from "./subscriptionPlanUpdateApis";
import Actions from "../../actions";
import { baseRouteMakerForSuperAdmin, routes } from "../../../constants/routeConsts";

// subscriptions plan -> get subscriptions plan api
export const getSubscriptionPlansAction = (dataToBeSent, setLoading) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.getSubscriptionPlans(dataToBeSent);
    if (response) {
      setLoading(false);
      dispatch(Actions.createAction(Actions.GET_SUBSCRIPTION_PLANS_LIST, {subscriptionPlans:response}))
      return response;
    } else {
      setLoading(false)
      return null;
    }
};

// subscriptions plan -> update subscriptions plan api
export const editSubscriptionPlanAction = (dataToBeSent, setLoading, navigate) => async (dispatch) => {
    setLoading(true);
    const response = await requestFromServer.updateSubscriptionPlan(dataToBeSent);
    if (response) {
      navigate(baseRouteMakerForSuperAdmin(routes.ACTIVE_SUBSCRIPTION));
      setLoading(false);
      return response;
    } else {
      setLoading(false)
      return null;
    }
};